export class DateUtil {
  public static getFirstDayTime(date: Date) : Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  public static getLastDayTime(date: Date) : Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, -1);
  }
}
